import { AuditLiveMention, toTimestamp } from '@mi-front/core';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';

import { usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';

export function LiveMentionPlayBtn(p: { liveMention: AuditLiveMention }) {
  const { $t } = useIntl();
  const play = usePlaybackPlay();

  const handlePlay = () => {
    play({
      startTs: toTimestamp(p.liveMention.datetime),
    });
  };

  return (
    <Button size="small" sx={{ marginTop: 0.5 }} onClick={handlePlay}>
      {$t({
        id: 'common.play',
        defaultMessage: 'Reproducir',
      })}
    </Button>
  );
}
